// extracted by mini-css-extract-plugin
export default {"btn":"loader_btn__rO+MZ","loader":"loader_loader__5x2cA"};